// Names must match the remote elements.json catalog exactly (e.g. Chart is singular).
export const ALLOWED_IN_CELL_ELEMENTS: ReadonlySet<string> = new Set([
  "Image",
  "Button",
  "Video",
  "Icon",
  "Divider",
  "Separator",
  "AnimatedImage",
  "AcceptButton",
  "Attachment",
  "Calendar",
  "Ticker",
  "AnimatedNumbers",
  "RichText",
  "Embedded",
  "BeforeAfter",
  "CollapsibleText",
  "Chart",
]);

export const isAllowedInCell = (name: string): boolean =>
  ALLOWED_IN_CELL_ELEMENTS.has(name);
